import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';

const useStyles = makeStyles((theme) => ({
	root: {
		'& > svg': {
			// margin: theme.spacing(2),
			width: 24,
			height: 24,
		},
	},
}));

function FavoritesIcon(props) {
	return (
		<SvgIcon viewBox="0 0 24 24">
			<path d="M1.43945 3C1.43945 2.44772 1.88717 2 2.43945 2H3.9796C5.42324 2 6.66217 3.02822 6.92822 4.44713L7.06938 5.2H19.2785C21.1324 5.2 22.5425 6.8646 22.2377 8.6932L21.3044 14.2932C21.0633 15.7398 19.8117 16.8 18.3452 16.8H9.69931C8.25566 16.8 7.01674 15.7718 6.75069 14.3529L4.96247 4.81571C4.87379 4.34274 4.46082 4 3.9796 4H2.43945C1.88717 4 1.43945 3.55228 1.43945 3Z" fill="white" />
			<path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M10.5 22C11.3284 22 12 21.3284 12 20.5C12 19.6716 11.3284 19 10.5 19C9.67157 19 9 19.6716 9 20.5C9 21.3284 9.67157 22 10.5 22Z" fill="white" />
			<path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M16.5 22C17.3284 22 18 21.3284 18 20.5C18 19.6716 17.3284 19 16.5 19C15.6716 19 15 19.6716 15 20.5C15 21.3284 15.6716 22 16.5 22Z" fill="white" />
		</SvgIcon>
	);
}

export default function SvgIconsColor() {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<FavoritesIcon />
		</div>
	);
}